document.addEventListener('DOMContentLoaded', function(){
  var toggle=document.querySelector('[data-menu-toggle]');
  var menu=document.querySelector('[data-mobile-menu]');
  if(toggle&&menu){toggle.addEventListener('click',function(){var open=menu.classList.toggle('is-open');toggle.setAttribute('aria-expanded',open?'true':'false');});}

  document.querySelectorAll('[data-variant-select]').forEach(function(select){
    select.addEventListener('change',function(){
      var option=select.options[select.selectedIndex];
      var wrap=select.closest('[data-product-form-wrap]');
      if(!wrap)return;
      var price=wrap.querySelector('[data-product-price]');
      var compare=wrap.querySelector('[data-product-compare]');
      var saving=wrap.querySelector('[data-product-saving]');
      var btn=wrap.querySelector('[data-add-button]');
      if(price)price.textContent=option.dataset.price||'';
      if(compare){if(option.dataset.compare){compare.hidden=false;compare.textContent=option.dataset.compare;}else{compare.hidden=true;compare.textContent='';}}
      if(saving){if(option.dataset.saving){saving.hidden=false;saving.textContent='Ahorra '+option.dataset.saving;}else{saving.hidden=true;saving.textContent='';}}
      if(btn){var available=option.dataset.available==='true';btn.disabled=!available;btn.textContent=available?'Añadir al carrito · '+(option.dataset.price||''):'Agotado';}
    });
  });
});

// Simple client-side rating for the welcome card. It does not publish a public review.
document.addEventListener('DOMContentLoaded', function(){
  var widget=document.querySelector('[data-rating-widget]');
  if(!widget)return;
  var stars=Array.prototype.slice.call(widget.querySelectorAll('[data-rating-value]'));
  var message=widget.querySelector('[data-rating-message]');
  var saved=parseInt(localStorage.getItem('trailed-store-rating')||'0',10);
  function paint(value){
    stars.forEach(function(star){
      var v=parseInt(star.getAttribute('data-rating-value'),10);
      star.classList.toggle('is-active',v<=value);
      star.setAttribute('aria-pressed',v===value?'true':'false');
    });
    if(message && value>0)message.textContent='Gracias por tu valoración: '+value+'/5';
  }
  if(saved>0 && saved<=5)paint(saved);
  stars.forEach(function(star){
    star.addEventListener('click',function(){
      var value=parseInt(star.getAttribute('data-rating-value'),10);
      localStorage.setItem('trailed-store-rating',String(value));
      paint(value);
    });
  });
});

// WOW product gallery + sticky add-to-cart
// Miniaturas: al pulsar una, pasa a ser la imagen grande.
// Variantes: si una variante tiene una imagen asignada en Shopify, cambia automáticamente a esa imagen.
document.addEventListener('DOMContentLoaded', function(){
  var gallery=document.querySelector('[data-product-gallery]');
  var main=gallery ? gallery.querySelector('[data-main-product-image]') : null;

  function showProductImage(src, alt, imageId){
    if(!main || !src) return;
    // El tema usa un src simple a propósito para que el navegador no mantenga
    // una imagen anterior mediante srcset al cambiar de miniatura.
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.src=src;
    if(alt) main.alt=alt;
    if(imageId) main.dataset.mainImageId=String(imageId);

    if(gallery){
      gallery.querySelectorAll('[data-product-thumb]').forEach(function(b){
        var sameId=imageId && String(b.dataset.imageId)===String(imageId);
        var sameSrc=!imageId && b.dataset.imageSrc===src;
        b.classList.toggle('is-active', !!(sameId || sameSrc));
      });
    }
  }

  if(gallery){
    gallery.querySelectorAll('[data-product-thumb]').forEach(function(btn){
      btn.addEventListener('click',function(){
        showProductImage(btn.dataset.imageSrc, btn.dataset.imageAlt, btn.dataset.imageId);
      });
    });
  }

  var form=document.querySelector('#MainProductForm');
  if(form){
    var select=form.querySelector('[data-variant-select]');
    if(select){
      select.addEventListener('change',function(){
        var option=select.options[select.selectedIndex];
        if(option && option.dataset.imageSrc){
          showProductImage(option.dataset.imageSrc, option.dataset.imageAlt, option.dataset.imageId);
        }
      });
    }
  }

  var sticky=document.querySelector('[data-sticky-buy]');
  if(sticky&&form){
    var submit=sticky.querySelector('[data-sticky-submit]');
    var stickyPrice=sticky.querySelector('[data-sticky-price]');
    var price=document.querySelector('[data-product-price]');
    var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){sticky.classList.toggle('is-visible',!entry.isIntersecting);});},{threshold:.15});
    observer.observe(form);
    if(submit){submit.addEventListener('click',function(){var add=form.querySelector('[data-add-button]');if(add&&!add.disabled)add.click();});}
    var stickySelect=form.querySelector('[data-variant-select]');
    if(stickySelect){stickySelect.addEventListener('change',function(){if(stickyPrice&&price)stickyPrice.textContent=price.textContent;});}
  }
});


// TrainerSp urgency offer: one 20-minute session countdown shared by the top bar and home popup.
document.addEventListener('DOMContentLoaded', function(){
  var bar=document.querySelector('[data-urgency-bar]');
  var offer=document.querySelector('[data-welcome-offer]');
  if(!bar && !offer) return;

  var durationSource=bar || offer;
  var duration=parseInt(durationSource.getAttribute('data-countdown-seconds') || '1200',10);
  var endKey='trainersp-offer-end-v2';
  var seenKey='trainersp-welcome-offer-seen-v2';
  var endAt=0;
  try{ endAt=parseInt(sessionStorage.getItem(endKey)||'0',10); }catch(e){}
  if(!endAt || endAt<=Date.now()){
    endAt=Date.now()+(duration*1000);
    try{ sessionStorage.setItem(endKey,String(endAt)); }catch(e){}
  }

  var barTimer=bar ? bar.querySelector('[data-urgency-timer]') : null;
  var progress=bar ? bar.querySelector('[data-urgency-progress]') : null;
  var popupTimer=offer ? offer.querySelector('[data-offer-timer]') : null;
  var tickInterval=null;

  function secondsLeft(){ return Math.max(0,Math.ceil((endAt-Date.now())/1000)); }
  function format(sec){
    var min=Math.floor(sec/60), s=sec%60;
    return String(min).padStart(2,'0')+':'+String(s).padStart(2,'0');
  }
  function renderAll(){
    var left=secondsLeft();
    var text=format(left);
    if(barTimer) barTimer.textContent=text;
    if(popupTimer) popupTimer.textContent=text;
    if(progress){ progress.style.width=Math.max(0,Math.min(100,(left/duration)*100))+'%'; }
    if(left<=0){
      if(bar) bar.classList.add('is-expired');
      if(offer && offer.classList.contains('is-open')) closeOffer(false);
      if(tickInterval){ window.clearInterval(tickInterval); tickInterval=null; }
    }
  }

  function closeOffer(markSeen){
    if(!offer) return;
    offer.classList.remove('is-open');
    document.documentElement.classList.remove('offer-open');
    window.setTimeout(function(){offer.hidden=true;},220);
    if(markSeen!==false){ try{ sessionStorage.setItem(seenKey,'1'); }catch(e){} }
  }
  function openOffer(){
    if(!offer || secondsLeft()<=0) return;
    var alreadySeen=false;
    try{ alreadySeen=sessionStorage.getItem(seenKey)==='1'; }catch(e){}
    if(alreadySeen) return;
    offer.hidden=false;
    window.requestAnimationFrame(function(){
      offer.classList.add('is-open');
      document.documentElement.classList.add('offer-open');
    });
  }

  if(offer){
    offer.querySelectorAll('[data-offer-close]').forEach(function(btn){btn.addEventListener('click',function(){closeOffer(true);});});
    var cta=offer.querySelector('[data-offer-cta]');
    if(cta) cta.addEventListener('click',function(){closeOffer(true);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape' && offer.classList.contains('is-open'))closeOffer(true);});
    window.setTimeout(openOffer,650);
  }

  renderAll();
  tickInterval=window.setInterval(renderAll,1000);
});


// PetClean one-product landing interactions
 document.addEventListener('DOMContentLoaded',function(){
  var section=document.querySelector('[data-pc-section]'); if(!section)return;
  var main=section.querySelector('.pc-hero__image');
  section.querySelectorAll('[data-pc-thumb]').forEach(function(btn){btn.addEventListener('click',function(){
    section.querySelectorAll('[data-pc-thumb]').forEach(function(x){x.classList.remove('is-active')});btn.classList.add('is-active');
    if(main&&btn.dataset.src){main.src=btn.dataset.src;main.removeAttribute('srcset');}
  })});
  var form=section.querySelector('[data-pc-form]'); if(!form)return;
  var price=form.querySelector('[data-pc-price]'),compare=form.querySelector('[data-pc-compare]'),buttonPrice=form.querySelector('[data-pc-btn-price]');
  form.querySelectorAll('[data-pc-pack] input').forEach(function(radio){radio.addEventListener('change',function(){
    form.querySelectorAll('[data-pc-pack]').forEach(function(card){card.classList.remove('is-selected')});
    var card=radio.closest('[data-pc-pack]');if(card)card.classList.add('is-selected');
    if(price)price.textContent=radio.dataset.price||'';if(buttonPrice)buttonPrice.textContent=radio.dataset.price||'';
    if(compare){if(radio.dataset.compare&&radio.dataset.compare!==radio.dataset.price){compare.hidden=false;compare.textContent=radio.dataset.compare}else{compare.hidden=true;compare.textContent=''}}
  })});
 });
